import { DISPLAY } from 'constants/display'

export const isBot = name => name === DISPLAY.botName

export const ALL = {
  label: 'All Notes',
  value: '',
}

export const HUMANS = {
  label: 'By People',
  value: 'human',
}

export const BOTS = {
  label: 'By Bots',
  value: 'ima_bot',
}

export const FILTERS = [ALL, HUMANS, BOTS]
